module.exports = __webpack_public_path__ + "static/media/WheatStage104.ee4cd43a.PNG";